<script setup>
// Marca do e-mail: cores e fontes (cópia do kit, editável aqui), pré-cabeçalho
// e logo. "Aplicar kit da marca" recopia do kit da conta.
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  template: { type: Object, required: true },
});
const emit = defineEmits(['theme', 'settings', 'applyKit']);
const { t } = useI18n();

const FONTS = [
  'Inter',
  'Manrope',
  'Poppins',
  'Montserrat',
  'Lato',
  'Roboto',
  'Nunito',
  'DM Sans',
  'Sora',
  'Playfair Display',
];
const COLORS = ['primary', 'accent', 'text', 'surface'];
const theme = computed(() => props.template.theme || {});
const settings = computed(() => props.template.settings || {});
const inputClass =
  'w-full rounded-lg border border-n-weak bg-n-solid-1 px-2.5 py-1.5 text-sm text-n-slate-12 focus:outline-none focus:ring-1 focus:ring-n-brand';
</script>

<template>
  <div class="flex flex-col gap-4 p-3">
    <button
      type="button"
      class="flex items-center justify-center gap-2 rounded-lg border border-n-brand px-3 py-2 text-sm font-medium text-n-brand hover:bg-n-brand/10"
      @click="emit('applyKit')"
    >
      <span class="i-lucide-palette" />
      {{ t('EMAIL_TEMPLATES.BUILDER.BRAND.APPLY_KIT') }}
    </button>
    <p class="text-[11px] text-n-slate-10">
      {{ t('EMAIL_TEMPLATES.BUILDER.BRAND.HINT') }}
    </p>

    <div class="grid grid-cols-2 gap-2">
      <label
        v-for="key in COLORS"
        :key="key"
        class="flex items-center gap-2 rounded-lg border border-n-weak px-2 py-1.5 text-xs text-n-slate-11"
      >
        <input
          type="color"
          :value="theme[key]"
          class="size-6 cursor-pointer rounded border-0 bg-transparent p-0"
          @input="emit('theme', { [key]: $event.target.value })"
        />
        {{ t(`EMAIL_TEMPLATES.BUILDER.BRAND.COLORS.${key}`) }}
      </label>
    </div>

    <label class="flex flex-col gap-1 text-xs text-n-slate-10">
      {{ t('EMAIL_TEMPLATES.BUILDER.BRAND.FONT_HEADING') }}
      <select
        :value="theme.font_heading"
        :class="inputClass"
        @change="emit('theme', { font_heading: $event.target.value })"
      >
        <option v-for="f in FONTS" :key="f" :value="f">{{ f }}</option>
      </select>
    </label>
    <label class="flex flex-col gap-1 text-xs text-n-slate-10">
      {{ t('EMAIL_TEMPLATES.BUILDER.BRAND.FONT_BODY') }}
      <select
        :value="theme.font_body"
        :class="inputClass"
        @change="emit('theme', { font_body: $event.target.value })"
      >
        <option v-for="f in FONTS" :key="f" :value="f">{{ f }}</option>
      </select>
    </label>

    <label class="flex flex-col gap-1 text-xs text-n-slate-10">
      {{ t('EMAIL_TEMPLATES.BUILDER.BRAND.PREHEADER') }}
      <input
        :value="settings.preheader"
        maxlength="150"
        :class="inputClass"
        @input="emit('settings', { preheader: $event.target.value })"
      />
      <span class="text-[11px]">{{
        t('EMAIL_TEMPLATES.BUILDER.BRAND.PREHEADER_HINT')
      }}</span>
    </label>
    <label class="flex flex-col gap-1 text-xs text-n-slate-10">
      {{ t('EMAIL_TEMPLATES.BUILDER.BRAND.LOGO_URL') }}
      <input
        :value="settings.logo_url"
        :class="inputClass"
        @input="emit('settings', { logo_url: $event.target.value })"
      />
    </label>
  </div>
</template>
